import React, { useEffect } from 'react';
import { useQuery } from '/src/api';
import { useModalsContext, useStoreConfigContext } from '/src/providers';
import {
    Form,
    Loader,
    Modal,
    InnerHtml,
    H2
} from '/src/components';
import graphQLQueries from './graph-ql-queries';

const TermsAndConditions = ({ url = 'terms-and-conditions.html' }) => {
    const { translate } = useStoreConfigContext();
    const { hideModal } = useModalsContext();
    const { data, isLoading, runQuery } = useQuery({
        query: graphQLQueries.route(url),
        queryKey: ['route'],
    });
    const { title, content } = data || {};

    useEffect(() => {
        runQuery();
    }, []);

    return (
        <Modal toggle={hideModal}>
            <Loader isLoading={isLoading}>
                <H2>{title || <>&nbsp;</>}</H2>
                <InnerHtml html={content} />
                <Form.Column mt>
                    <Form.Button onClick={hideModal}>
                        {translate('Close')}
                    </Form.Button>
                </Form.Column>
            </Loader>
        </Modal>
    );
};

export default TermsAndConditions;
